import { useEffect } from "react";
import { global } from "../../shared/libs/Global";
import { initFcm } from "../../shared/libs/firebasePush";

/** 로그인 직후 화면 로딩(메뉴/대시보드)과 겹치지 않게 FCM 초기화를 미루는 시간 */
const INIT_DELAY_MS = 5000;

/**
 * 로그인된 사용자가 확인되면 FCM 푸시를 초기화한다.
 * MainLayout에 마운트되므로 새 로그인/새로고침(F5) 모두에서 동작한다.
 * (DeployNotificationListener와 동일한 패턴)
 *
 * 토큰 발급이 구글 서버 통신이라 수 초 걸릴 수 있어, 로그인 직후 렌더링과
 * 경쟁하지 않도록 지연 실행한다. 알림은 부가기능이라 몇 초 늦어도 무방하다.
 */
export default function FcmPushInitializer() {
  const userInfo = global((state) => state.userInfo);

  useEffect(() => {
    if (!userInfo?.cd_user) {
      return;
    }
    const timer = window.setTimeout(() => {
      initFcm();
    }, INIT_DELAY_MS);
    return () => window.clearTimeout(timer);
  }, [userInfo?.cd_user]);

  return null;
}
